(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TourSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// init dual calendars
		Adzuki.Web.DualCalendar.initOnForm($form);

		Adzuki.Typeahead(
			'.location-search',
			'/TourSearch/locations',
			function select(item) {
				$form.find('.city-id').val(item.city_id);
				$form.find('.country-id').val(item.country_id);
			}
		);

		// when selecting a "from" date, change the "to" date to be +1 month
		$form.find("input.start-date").on('dp.change', function setEndDate(event, args) {
			// args.linked_dtp.date(args.date_obj.add(1, 'month'));
		});
	};

}(jQuery, window.Adzuki || {}));
